/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetToolMetadataBatchRequestBody,
  SetToolMetadataBatchRequestBody$Outbound,
  SetToolMetadataBatchRequestBody$outboundSchema,
} from "../components/settoolmetadatabatchrequestbody.js";

export type SetMcpServerToolMetadataBatchSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SetMcpServerToolMetadataBatchSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SetMcpServerToolMetadataBatchSecurity = {
  option1?: SetMcpServerToolMetadataBatchSecurityOption1 | undefined;
  option2?: SetMcpServerToolMetadataBatchSecurityOption2 | undefined;
};

export type SetMcpServerToolMetadataBatchRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setToolMetadataBatchRequestBody: SetToolMetadataBatchRequestBody;
};

/** @internal */
export type SetMcpServerToolMetadataBatchSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SetMcpServerToolMetadataBatchSecurityOption1$outboundSchema:
  z.ZodMiniType<
    SetMcpServerToolMetadataBatchSecurityOption1$Outbound,
    SetMcpServerToolMetadataBatchSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setMcpServerToolMetadataBatchSecurityOption1ToJSON(
  setMcpServerToolMetadataBatchSecurityOption1:
    SetMcpServerToolMetadataBatchSecurityOption1,
): string {
  return JSON.stringify(
    SetMcpServerToolMetadataBatchSecurityOption1$outboundSchema.parse(
      setMcpServerToolMetadataBatchSecurityOption1,
    ),
  );
}

/** @internal */
export type SetMcpServerToolMetadataBatchSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SetMcpServerToolMetadataBatchSecurityOption2$outboundSchema:
  z.ZodMiniType<
    SetMcpServerToolMetadataBatchSecurityOption2$Outbound,
    SetMcpServerToolMetadataBatchSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function setMcpServerToolMetadataBatchSecurityOption2ToJSON(
  setMcpServerToolMetadataBatchSecurityOption2:
    SetMcpServerToolMetadataBatchSecurityOption2,
): string {
  return JSON.stringify(
    SetMcpServerToolMetadataBatchSecurityOption2$outboundSchema.parse(
      setMcpServerToolMetadataBatchSecurityOption2,
    ),
  );
}

/** @internal */
export type SetMcpServerToolMetadataBatchSecurity$Outbound = {
  Option1?: SetMcpServerToolMetadataBatchSecurityOption1$Outbound | undefined;
  Option2?: SetMcpServerToolMetadataBatchSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SetMcpServerToolMetadataBatchSecurity$outboundSchema:
  z.ZodMiniType<
    SetMcpServerToolMetadataBatchSecurity$Outbound,
    SetMcpServerToolMetadataBatchSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(
        z.lazy(() =>
          SetMcpServerToolMetadataBatchSecurityOption1$outboundSchema
        ),
      ),
      option2: z.optional(
        z.lazy(() =>
          SetMcpServerToolMetadataBatchSecurityOption2$outboundSchema
        ),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function setMcpServerToolMetadataBatchSecurityToJSON(
  setMcpServerToolMetadataBatchSecurity: SetMcpServerToolMetadataBatchSecurity,
): string {
  return JSON.stringify(
    SetMcpServerToolMetadataBatchSecurity$outboundSchema.parse(
      setMcpServerToolMetadataBatchSecurity,
    ),
  );
}

/** @internal */
export type SetMcpServerToolMetadataBatchRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetToolMetadataBatchRequestBody: SetToolMetadataBatchRequestBody$Outbound;
};

/** @internal */
export const SetMcpServerToolMetadataBatchRequest$outboundSchema: z.ZodMiniType<
  SetMcpServerToolMetadataBatchRequest$Outbound,
  SetMcpServerToolMetadataBatchRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setToolMetadataBatchRequestBody:
      SetToolMetadataBatchRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      setToolMetadataBatchRequestBody: "SetToolMetadataBatchRequestBody",
    });
  }),
);

export function setMcpServerToolMetadataBatchRequestToJSON(
  setMcpServerToolMetadataBatchRequest: SetMcpServerToolMetadataBatchRequest,
): string {
  return JSON.stringify(
    SetMcpServerToolMetadataBatchRequest$outboundSchema.parse(
      setMcpServerToolMetadataBatchRequest,
    ),
  );
}
